<template>
  <div id="lang">
    <p style="display: none">
      <a style="color:white" href="javascript:void(0)" @click="setLang('vi')" class=" typo-l6">
        {{ $t('vietnamese')}}
      </a>
      <a style="color:white" href="javascript:void(0)" @click="setLang('en')" class=" typo-l6">
        {{ $t('english') }}
      </a>
    </p>
    <p>
      <b-form-select id="basicSelect" v-model="current_lang" v-bind:value="current_lang"
                     size="sm"
                     :plain="true"
                     :options="[
                       {
                         text: $t('vietnamese'),
                         value: 'vi'
                       },
                       {
                         text: $t('english'),
                         value: 'en'
                       }
                     ]"
      >
      </b-form-select>
    </p>
  </div>
</template>
<script>
  import Vue from 'vue'
  import * as Cookies from 'js-cookie'

  export default {
    name: 'lang',
    data: function () {
      return {
        current_lang: 'en'
      }
    },
    methods: {
      setLang: function (lang) {
        this.$store.dispatch('setLang', lang)
        Vue.config.lang = lang
        Cookies.set('locale', lang)
        this.$session.set('lang', lang)
        Vue.axios.defaults.headers.common['Lang'] = lang
      }
    },
    created() {
      this.current_lang = this.$session.get('lang') || 'en'
      this.setLang(this.current_lang)
    },
    watch: {
      current_lang: function (val) {
        this.setLang(val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Partials/ChangeLangues.vue